// Handoff key for the uploaded-RA result between the upload page and its completion screen.
export const UPLOAD_RESULT_KEY = "ra-upload-result";
